<template>
  <div>
    <div class="container-fluid m-0 p-0 mt-5 pt-5">
      <div class="row justify-content-center mt-5 pt-5">
        <div class="col-md-7 t-center">
          <h1>Impressum</h1>
        </div>
      </div>

      <div class="row bg-white pt-5 pb-5 border-bottom justify-content-center">
        <div class="col-md-4 p-2 t-center">
          <p>
            {{ $t("adresseName") }}<br />
            {{ $t("adresseStrasse") }}<br />
            {{ $t("adresseOrt") }}
          </p>
          <h5 v-if="$t('Geschaeftsfuehrer') != ''">
            Vertreten durch die Geschäftsführer:<br/> {{ $t("Geschaeftsfuehrer") }}
          </h5>
          
          <p v-if="$t('Registereintrag') != ''">
           Eintragung im Handelsregister.
         <br/>
           Registergericht:{{ $t("Registereintrag") }}
          <br/>
            Registernummer: {{ $t("Registernummer") }}
          </p>
          <p>
            <i class="bi bi-info-square pe-2"></i>{{ $t("adresseMail") }}@{{
              $t("adresseMailDomain")
            }}
          </p>
          <p><i class="bi bi-telephone pe-2"></i>{{ $t("adresseTel") }}</p>
          <p><i class="bi bi-printer pe-2"></i>{{ $t("adresseFax") }}</p>
          <h4>{{ $t("steuerId") }}</h4>
          <p>{{ $t("steuerNummer") }}</p>

          <h4>Bankverbindung</h4>
          <p>
            Kontoinhaber:{{ $t("Kontoinhaber") }} <br />
            Kontonummer:{{ $t("Kontonummer") }}<br />
            BLZ:{{ $t("BLZ")}}<br />
            Kreditinstitut:{{ $t("Kreditinstitut") }}<br />
            SWIFT:{{ $t("SWIFT")}}<br />
            IBAN:{{ $t("IBAN") }}
          </p>
          
        </div>
      </div>
    </div>
 
  </div>
</template>

<script>
export default {
  name: "ImpressumPage",

  data() {
    return {
      newSite: null,
    };
  },
  components: {},
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
